<mat-card>
    <mat-card-content class="newOrder">
        <div class="titleHead">
            <title-back [addTitle]="true" [Title]="'Lead Details: '" (back)="closeDetails()"> </title-back>
            <div fxLayout="row wrap" class="chipset">
                <mat-chip class="sleek-chip secondary-chip">{{userObj.first_name}}
                    {{userObj.last_name}}</mat-chip>
                <mat-chip class="secondary-chip sleek-chip">{{userObj.company_name}}</mat-chip>
                <mat-chip class="secondary-chip sleek-chip">{{userObj.approval_status | titlecase}}</mat-chip>
            </div>
        </div>
        <div fxLayout="column" class="detailBox">
            <span class="boxTitle">USER DETAILS</span>
            <app-text-field [isEditable]="isEditable" [label]="'First Name*'" [name]="'first_name'"
                [(ngModel)]="userObj.first_name" [minlength]="3" [errors]="userObj.error?.first_name">
            </app-text-field>

            <app-text-field [isEditable]="isEditable" [label]="'Last Name*'" [name]="'last_name'"
                [(ngModel)]="userObj.last_name" [minlength]="3" [errors]="userObj.error?.last_name">
            </app-text-field>

            <app-text-field [isEditable]="false" [label]="'Email'" [name]="'email'" [(ngModel)]="userObj.email"
                [minlength]="5" [errors]="userObj.error?.email">
            </app-text-field>
            <span *ngIf="userObj.is_otp_verified" class="verification"> <i class="flaticon-checked"></i>
                Verified</span>
            <app-phone-field [isEditable]="isEditable" [label]="'Phone*'" [(ngModel)]="userObj.phone"
                class="align-items-center" placeholder="XXXXXXXXXX" [errors]="userObj.error?.phone"></app-phone-field>
        </div>

        <div fxLayout="column" class="detailBox">
            <span class="boxTitle">COMPANY DETAILS</span>
            <app-text-field [isEditable]="false" [label]="'Company Name*'" [name]="'company_name'"
                [(ngModel)]="userObj.company_name" [errors]="userObj.error?.company_name">
            </app-text-field>

            <app-mat-auto-search [isEditable]="false" [label]="'Country*'" [name]="'country'"
                [ngModel]="userObj.country" (ngModelChange)="filterStates($event)" [listUrl]="country_url"
                [setSearchValue]="false" [idField]="null" [displayField]="'name'" [errors]="userObj.error?.country">
            </app-mat-auto-search>

            <app-mat-auto-search [label]="'State*'" [isEditable]="false" [name]="'state'" [(ngModel)]="userObj.state"
                [idField]="null" [setSearchValue]="false" [displayField]="'name'" [listUrl]="state_url"
                [errors]="userObj.error?.state">
            </app-mat-auto-search>

            <app-text-field [isEditable]="false" [label]="'Address*'" [name]="'address'" [(ngModel)]="userObj.address"
                [isMultiline]="true" [minlength]="5" [errors]="userObj.error?.address">
            </app-text-field>
        </div>

        <div fxFlex="100" class="adminBox">
            <span class="boxTitle">ADMIN-USE ONLY</span>
            <div class="subBox">
                <span class="subBoxTitle">Administrative Action</span>
                <app-select-field [isEditable]="isEditable" [label]="'Assign Role*'" [name]="'role'"
                    [(ngModel)]="userObj.role" [idField]="null" [displayField]="'name'"
                    [options]="profileRoleList?.results" [tooltipIcon]="true" [delay]="0"
                    [tooltipName]="'Choose the role of the user. Admins have more privileges than employees, so select accordingly.'"
                    [errors]="userObj.error?.role">
                </app-select-field>

                <app-mat-auto-search [isEditable]="isEditable" [label]="'Map Company*'" [name]="'company'"
                    [(ngModel)]="userObj.company" (ngModelChange)="getCompanyDetails($event)" [idField]="null"
                    [displayField]="'legal_name'" [listUrl]="company_url" [tooltipIcon]="true" [delay]="0"
                    [tooltipName]="'Choose the company associated with this lead. This helps establish a clear link between lead and their corresponding company.'"
                    [setSearchValue]="true" [labelItemTemplate]="companySelectedItem" [itemTemplate]="companyItem"
                    [errors]="userObj.error?.company">
                </app-mat-auto-search>

                <app-select-field [isEditable]="isEditable" [label]="'Approve Login*'" [name]="'login_status'"
                    [tooltipIcon]="true" [delay]="0"
                    [tooltipName]="'Select whether this lead should be granted access(Yes) or not(Not) to ARCON system. Approval grants login privileges.'"
                    [ngModel]="userObj.is_login_approved" (ngModelChange)="setRemarks($event)" [idField]="'id'"
                    [displayField]="'value'" [options]="userObj.loginApprovalList"
                    [errors]="userObj.error?.is_login_approved">
                </app-select-field>

                <div *ngIf="userObj.approval_status == 'company_unassigned' || userObj.approval_status == 'pending'"
                    class="bypassVerification">
                    <div class="inputTitle">
                        <span>Skip Verification*</span><i MatSuffix
                            matTooltip="Company Admin user would not have to verify the user if you choose to skip verification. "
                            matTooltipPosition="right" class="flaticon-message"></i>
                    </div>
                    <mat-button-toggle-group [(ngModel)]="userObj.bypass_external_verification"
                        name="bypass_verification" [disabled]="!isEditable">
                        <mat-button-toggle [value]="true">Yes</mat-button-toggle>
                        <mat-button-toggle [value]="false">No</mat-button-toggle>
                    </mat-button-toggle-group>
                    <ul *ngIf="userObj.error?.bypass_external_verification?.length" class="errorList">
                        <li *ngFor="let item of userObj.error?.bypass_external_verification" class="error">
                            {{item}}</li>
                    </ul>
                </div>

                <ng-container *ngIf="userObj.is_login_approved=='no'">
                    <app-select-field [isEditable]="isEditable" [label]="'Decline Reason*'" [name]="'rejection_reason'"
                        [(ngModel)]="userObj.rejection_reason" [idField]="null" [displayField]="'value'"
                        [tooltipIcon]="true" [delay]="0"
                        tooltipName="'If you're rejecting the lead, select the reason for the rejection'"
                        [options]="rejectionReasonList?.results" [errors]="userObj.error?.rejection_reason">
                    </app-select-field>
                </ng-container>

                <app-text-field [isEditable]="isEditable" [label]="'Remarks'" [name]="'remarks'"
                    [(ngModel)]="userObj.remarks" [tooltipIcon]="true" [delay]="0"
                    [tooltipName]="'Add any additional comments, notes or observations related to this lead verification process.'"
                    [minlength]="5" [isMultiline]="true" [errors]="userObj.error?.remarks">
                </app-text-field>

                <div *ngIf="userObj.approval_status!='company_unassigned' && userObj.approval_status!='pending'">
                    <label>{{userObj.approval_status == 'rejected' ? 'Rejected By' : 'Approved By'}}</label>
                    <span>{{userObj.approved_rejected_by.first_name}}
                        {{userObj.approved_rejected_by.last_name}} at {{userObj.approved_rejected_at |
                        date:'dd MMM, yyyy hh:mm a'}}</span>
                </div>

            </div>
            <div class="subBox">
                <span class="subBoxTitle">Login Details</span>
                <div><label>User Creation Date</label>
                    <span>{{userObj.created_at | date:'dd MMM, yyyy'}}</span>
                </div>
                <div><label>Location</label>
                    <span>{{userObj.client_location}}</span>
                </div>
                <div><label>Device</label>
                    <span>{{userObj.client_browser}} {{userObj.client_device}}</span>
                </div>
                <div><label>OTP Verification</label>
                    <span>{{userObj.otp_verified_at | date : 'dd MMM, yyyy hh:mm a'}}</span>
                </div>

                <!-- <label>Device</label><span>{{userObj.client_device}}</span><br> -->

            </div>
        </div>
        <div class="actionBtn">
            <button *ngIf="isEditable" mat-raised-button class="addBtn " (click)="submitUserApproval()">Save</button>
        </div>
    </mat-card-content>
</mat-card>

<ng-template #companyItem let-item let-index>
    <div fxFlex="100" fxLayout="column" class="managerListShow">
        <span class="fullname">
            {{ item?.name }}
        </span>
        <span class="email">
            {{item?.primary_branch?.address}}
        </span>
    </div>
</ng-template>

<ng-template #companySelectedItem let-item>
    {{ item?.name }}
</ng-template>